import styled from 'styled-components';

const AuthTitle = styled.h1`
  color: ${(props) => props.theme.colors.primaryBlack};
  font-size: 32px;
  font-weight: 600;
  margin: 0;
`;
export default AuthTitle;
